import { InjectionToken } from '@angular/core';
export const STORAGE_DOMAIN = new InjectionToken<string>('CertMetrics Storage Domain Prefix');
